import React, {useEffect, useRef, useState} from "react";
import {HelpHttp} from "helpers/HelpHttp";
import ClientCrudTable from "./ClientCrudTable";
import ClientCrudTableForm from "./ClientCrudTableForm";
import ClientCrudTableSearch from "./ClientCrudTableSearch";
import ClientCrudTableSearchModal from "./ClientCrudTableSearchModal";
import ClientCrudTableModal from "./ClientCrudTableModal";
import ClientCrudTableModal2 from "./ClientCrudTableModal2";

import SpinnerBootrap from "components/SpinnerBootrap";
import RequestError from "components/RequestError";
import Swal from "sweetalert2";
import {Modal} from "react-bootstrap";
import { useDireccion } from "hooks/useDireccion";
import { useEmail } from "hooks/useEmail";
import SearchModal from "./SearchModal";
import SearchModalEmail from "./SearchModalEmail";
import TableModal from "./TableModal";
import TableModalEmail from "./TableModalEmail";

import Table2Modal from "./Table2Modal";
import Table2ModalEmail from "./Table2ModalEmail";



const {REACT_APP_API} = process.env;
const initialForm = 
    {   
        _id: null, 
        name: '', 
        lastName: '', 
        numDocument: '', 
        documentType: '',
        mail: '', 
        hasActiveReserve: null, 
        hasMora: null,
        hasEntidad: null, 
        maximumFinancingAmount: ''
    };
let amountClientsPages = 0;
let amountClients = 0;
let amountClientsPorPage = 5;

let amountLinesPages = 0;
let amountLines = 0;
let amountLinesPorPage = 5;

const ClientCrud = () => {

    const [Lines, setLines] = useState(null);
    const [LinesWhitClient, setLinesWhitClient] = useState(null);
    const [numDocumentFromModal, setnumDocumentFromModal] = useState(null);
    const [find, setFind] = useState(null);
    const [clients, setClients] = useState(null);
    const [dataToEdit, setDataToEdit] = useState(null);
    const [form, setForm] = useState(initialForm);
    const [requestError, setRequestError] = useState(null);
    const [errors, setErrors] = useState(null);
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [numberPageLine, setNumberPageLine] = useState(1);
    const [numberPageClient, setNumberPageClient] = useState(1);
    const [modalVincularDireccion, setModalVincularDireccion] = useState(false);
    const [modalVincularCorreo, setModalVincularCorreo] = useState(false);
    const [itemsPerPage, setItemsPerPage] = useState(amountClientsPorPage);
    const [hasSearch, setHasSearch] = useState(false);
    const searchFormRef = useRef();

    const resetSearch = () => {
        setHasSearch(false);
        searchFormRef?.current?.reset();
    }
    
    const [selectedClient, setSelectedClient] = useState({});

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    let api = HelpHttp();
    let url = `${REACT_APP_API}/clients`
    const editData = (el) => {
        setDataToEdit(el);
        setErrors(null);
    }

    const vinculedLine = (numLine, data) =>{

        let dataFormat = {
            documentClient: numDocumentFromModal,
            number: data.number,
            type: data.type,
            numeroReportes: data.numeroReportes,
            primerReporte: data.primerReporte,
            ultimoReporte: data.ultimoReporte
        }
        
        let endPoint = `${REACT_APP_API}/lines/${data._id}`
        let options = {body: dataFormat, headers: {'content-type': 'application/json'}};
        api.put(endPoint, options).then(res => {
            //console.log(res);
            if (res.err) {
                //console.log(clients);
                setRequestError(res);
            } else {
                if (res.status) {
                    listLinesByDocumentClient(numDocumentFromModal);
                    getAmountLines();
                    getAmountClients();
                } else {
                    setErrors(res.errors);
                }
            }
        });

        
    }
    const desvinculedLine = (numLine,documentClient, data) =>{
        
        let dataFormat = {
            documentClient: "",
            number: data.number,
            type: data.type,
            numeroReportes: data.numeroReportes,
            primerReporte: data.primerReporte,
            ultimoReporte: data.ultimoReporte            
        }

        let endPoint = `${REACT_APP_API}/lines/${data._id}`
        let options = {body: dataFormat, headers: {'content-type': 'application/json'}};
        api.put(endPoint, options).then(res => {
            //console.log(res);
            if (res.err) {
                console.log();
                setRequestError(res);
            } else {
                if (res.status) {  
                    listLinesByDocumentClient(documentClient);
                    getAmountLines();
                    getAmountClients();
                } else {
                    setErrors(res.errors);
                }
            }
        });
    }
    const validateInputOfSearch = () => {
        return Swal.fire({
            title: 'Seleccione una opción de busqueda.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
        })  
    }
    // const validateLineByDocumentClient = (documentClient) => {
    //     let urlLine = `${REACT_APP_API}/lines/findByDocumentClient/?documentClient=${documentClient}`
    //     let numberOfLines = "";
    //     let typeClient = "";
    //     api.get(urlLine).then(res => {
    //         if (res.err) {
    //             setRequestError(res);
    //         } else {
    //             console.log("METODO el documento : "+documentClient + " tiene : " +res.length +" lineas" );
    //             console.log(res);
    //             numberOfLines = res.length
    //             if (res.length > 0) {
    //                 typeClient="Cliente Claro";
    //             }
    //         }
    //     });
    //     return numberOfLines,typeClient;
    // }
    const getAmountLines = () => {
        setLoading(true);
        let urlLine = `${REACT_APP_API}/lines/findAllWhitoutClient`
        api.get(urlLine).then(res => {
            if (res.err) {
            } else {
                amountLines = res.length;
                amountLinesPages = Math.ceil(amountLines / amountLinesPorPage);
                listLines(numberPageLine)
            }
        });
    }

    const listLines = (numberPage = 1) => {
        setLoading(true);
        setNumberPageLine(numberPage);
        let urlLine = `${REACT_APP_API}/lines/findAllWhitoutClient/?page=${numberPage}&limit=${amountLinesPorPage}`
        api.get(urlLine).then(res => {
            if (res.err) {
                setLines(null);
                setRequestError(res);
            } else {
                setLines(res);
                setRequestError(null);
            }
            setLoading(false);
        });
    }
    const listLinesByNumber = (number) => { // modal
        setLoading(true);
        // let urlLine = `${REACT_APP_API}/lines/findAllByNumber/?number=${number}`
        let urlLine = `${REACT_APP_API}/lines/findAllWhitoutClient/?number=${number}`
        
        api.get(urlLine).then(res => {
            if (res.err) {
                setLines(null);
                setRequestError(res);
            } else {
                console.log(res)
                setLines(res);
                console.log("listLines");
                console.log(res);
                setRequestError(null);
            }
            setLoading(false);
        });
    }
    const listLinesByDocumentClient = (documentClient) => {
        setLoading(true);
        let urlLine = `${REACT_APP_API}/lines/findByDocumentClient/?documentClient=${documentClient}`
        api.get(urlLine).then(res => {
            if (res.err) {
                setLinesWhitClient(null);
                setRequestError(res);
            } else {
                setLinesWhitClient(res);
                console.log("listLinesByDocumentClient : "+ documentClient);
                console.log(res);
                setRequestError(null);
            }
            setLoading(false);
        });
    }
    const getAmountClients = () => {
        setLoading(true);
        api.get(url).then(res => {
            if (res.err) {
            } else {
                amountClients = res.length;
                listClients(numberPageClient)
            }
        });

    }

    const listClients = (numberPage = 1, limit = itemsPerPage) => {
        setLoading(true);
        setNumberPageClient(numberPage)
        api.get(`${url}/?page=${numberPage}&limit=${limit}`).then(res => {
            amountClientsPages = Math.ceil(amountClients / limit)
            if (res.err) {
                setClients(null);
                setRequestError(res);
            } else {
                setClients(res);
                setRequestError(null);
            }
            setLoading(false);
        });
    }
    const listClientsByNumDocument = () => { // home
        console.log(find);
        
        if (find === null || find.find === "") {
            Swal.fire({
                title: 'Ingrese un número de documento',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
            })
        } else {
            const endPoint = `${url}/findByNumDocument/?numDocument=${find.find}`;
            setLoading(true);
            api.get(endPoint).then(res => {
                if (res.err) {
                    setClients(null);
                    setRequestError(res);
                } else {
                    //console.log("tamaño : "+res.length);
                    console.log(find.find);
                    setClients(res);
                    setRequestError(null);
                    setHasSearch(true);
                }
                setLoading(false);
            });  
        }
    }
    const listClientsByMail = () => { // home
        console.log(find);
        if (find === null || find.find === "") {
            Swal.fire({
                title: 'Ingrese un correo',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
            })
        } else {
            const endPoint = `${url}/findByMail/?mail=${find.find}`;
            setLoading(true);
            api.get(endPoint).then(res => {
                if (res.err) {
                    setClients(null);
                    setRequestError(res);
                } else {
                    setClients(res);
                    setRequestError(null);
                    setHasSearch(true);
                }
                setLoading(false);
            });
        }
    }
    const listClientsByName = () => { // home
        console.log(find);

        if (find === null || find.find === "") {
            Swal.fire({
                title: 'Ingrese un nombre',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
            })
        } else {
            const endPoint = `${url}/findByName/?name=${find.find}`;
            setLoading(true);
            api.get(endPoint).then(res => {
                if (res.err) {
                    setClients(null);
                    setRequestError(res);
                } else {
                    setClients(res);
                    setRequestError(null);
                    setHasSearch(true);
                }
                setLoading(false);
            });
        }
    }
    const createData = (data) => {
        let options = {body: data, headers: {'content-type': 'application/json'}};
            api.post(url, options).then(res => {
                //console.log(res);
                if (res.err) {
                    setRequestError(res);
                } else {
                    if (res.status) {
                        getAmountClients();
                        handleReset();
                        Swal.fire('¡Ok!', res.message, 'success');
                    } else {
                        setErrors(res.errors);
                    }
                }
            });  
    }
    const updateData = (data) => {
        console.log("-----------start method updateData");
        console.log("data :",data);
        console.log("data :",data._id);

        if(data.documentType === "" || data.documentType === "Seleccione"){
            Swal.fire({
                title: 'Seleccione un tipo de Documento.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
            })
        }else{
            let endPoint = `${url}/${data._id}`;
            console.log(endPoint);
            let options = {body: data, headers: {'content-type': 'application/json'}};
            api.put(endPoint, options).then(res => {
                //console.log(res);
                if (res.err) {
                    console.log(clients);
                    setRequestError(res);
                } else {
                    if (res.status) {
                        getAmountClients();
                        handleReset();
                        Swal.fire('¡Ok!', res.message, 'success');
                    } else {
                        setErrors(res.errors);
                    }
                }
            });
        }
        console.log("-----------end method updateData");
    }
    const deleteData = (id) => {
        Swal.fire({
            title: '¿Está seguro?',
            text: "¡No podrás revertir esto!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: '¡Sí, bórralo!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                const endPoint = `${url}/${id}`;
                let options = {headers: {'content-type': 'application/json'}};
                api.del(endPoint, options).then(res => {
                    console.log(res);
                    if (res.err) {
                        setRequestError(res);
                    } else {
                        if (res.status) {
                            Swal.fire('¡Eliminado!', res.message, 'success');
                            getAmountClients();
                            // handleReset();
                        } else {
                            setErrors(res.errors);
                        }
                    }
                });
            }
        });
    }
    const handleReset = (e) => {
        setErrors(null);
        setForm(initialForm);
        setDataToEdit(null);
    }

    const {
        vinculedDirecciones,
        direcciones,
        getVinculedDirections,
        loading: loadingDireccion,
        page: pageDireccion,
        totalPages: totalPagesDireccion,
        status: statusDireccion,
        likeDireccion,
        unlikeDireccion,
        getDirecciones,
        setPage: setPageDireccion
    } = useDireccion();

    const {
        vinculedEmails,
        emails,
        getVinculedEmails,
        loading: loadingEmail,
        page: pageEmail,
        totalPages: totalPagesEmail,
        status: statusEmail,
        likeEmail,
        unlikeEmail,
        getEmails,
        setPage: setPageEmail
        
    } = useEmail();

    const [isSearchedDireccion, setIsSearchedDireccion] = useState({
        search: '',
        option: '',
        state: false
    })

    const [isSearchedEmail, setIsSearchedEmail] = useState({
        search: '',
        option: '',
        state: false
    })

    const desvinculedDirection = async ({direccion}) => {
        const mail = await unlikeDireccion({direccion, cliente: selectedClient});
        if(mail){
            await getVinculedDirections({mail});
            await getDirecciones({});
            getAmountClients();

            // listClients({});
        }
    }

    const vinculedDireccion = async ({direccion}) => {
        const mail = await likeDireccion({direccion, cliente: selectedClient});
        if(mail){
            await getVinculedDirections({mail});
            await getDirecciones({});
            getAmountClients();
            // listClients({});
        }
    }

    const desvinculedEmail = async ({email}) => {
        const numDocument = await unlikeEmail({email, cliente: selectedClient});
        if(numDocument){
            await getVinculedEmails({numDocument});
            await getEmails({});
            getAmountClients();

            // listClients({});
        }
    }

    const vinculedEmail = async ({email}) => {
        const numDocument = await likeEmail({email, cliente: selectedClient});
        if(numDocument){
            await getVinculedEmails({numDocument});
            await getEmails({});
            getAmountClients();
            // listClients({});
        }
    }
   
    const handleHideModalVincularDireccion = () => {
        setSelectedClient({});
        setModalVincularDireccion(false);
    }

    const handleHideModalVincularCorreo = () => {
        setSelectedClient({});
        setModalVincularCorreo(false);
    }

    useEffect(() => {
        if (dataToEdit) {
            setForm(dataToEdit)
        } else {
            setForm(initialForm);
        }
    }, [dataToEdit]);

    useEffect(() => {
        getAmountClients();
        getAmountLines();
        // eslint-disable-next-line
    }, []);

    return (
        <>
            <div className="container">
                <div className="row my-md-4">
                    <h4 className="d-flex justify-content-center">Gestión de Clientes</h4>
                    {requestError && <RequestError msg={requestError}/>}
                    <div className="col-12 p-0">
                        <ClientCrudTableSearch 
                            setFind={setFind}
                            validateInputOfSearch={validateInputOfSearch} 
                            listClientsByNumDocument={listClientsByNumDocument}
                            listClientsByMail={listClientsByMail}
                            listClientsByName={listClientsByName}
                            formRef={searchFormRef}
                        />
                    </div>
                    <div className="col-12 p-0">
                        <ClientCrudTableForm 
                            createData={createData} 
                            updateData={updateData} 
                            handleReset={handleReset}
                            setDataToEdit={setDataToEdit} 
                            form={form} 
                            initialForm={initialForm} 
                            setForm={setForm}
                            errors={errors}/>
                    </div>
                    <div className="col-12 p-0">
                        {loading && <SpinnerBootrap/>}
                        {clients && 
                        <ClientCrudTable 
                            getVinculedDirections={getVinculedDirections}
                            setModalVincularDireccion={setModalVincularDireccion}
                            getVinculedEmails={getVinculedEmails}
                            setModalVincularCorreo={setModalVincularCorreo}
                            setSelectedClient={setSelectedClient}

                            clients={clients} 
                            editData={editData} 
                            deleteData={deleteData}
                            listClients={listClients}
                            listLines={listLines}
                            listLinesByDocumentClient={listLinesByDocumentClient}
                            handleShow={handleShow}
                            vinculedLine={vinculedLine}
                            setnumDocumentFromModal={setnumDocumentFromModal}
                            amountPages={amountClientsPages}
                            itemsPerPage={itemsPerPage}
                            setItemsPerPage={setItemsPerPage}
                            resetSearch={resetSearch}
                            hasSearched={hasSearch}
                        />}
                    </div>
                </div>
            </div>

            <Modal show={modalVincularDireccion} onHide={handleHideModalVincularDireccion}>
                <Modal.Header closeButton>
                    <Modal.Title>Vinculación con Direcciones</Modal.Title>
                </Modal.Header>
                            
                <Modal.Body>
                    <div className="col-12">
                        <SearchModal getDirecciones={getDirecciones} setIsSearched={setIsSearchedDireccion}/>
                    </div>
                    
                    <div className="col-12">
                        {loadingDireccion && <SpinnerBootrap/>}
                        <TableModal vinculedDireccion={vinculedDireccion} direcciones={direcciones} getDirecciones={getDirecciones} totalPages={totalPagesDireccion} setPage={setPageDireccion} page={pageDireccion} isSearched={isSearchedDireccion} setIsSearched={setIsSearchedDireccion} />                        
                    </div>
                    
                    <div className="col-12">
                        {loadingDireccion && <SpinnerBootrap/>}
                        
                        <Table2Modal
                            vinculedDirecciones={vinculedDirecciones}
                            desvinculedDirection={desvinculedDirection} 
                        />
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={modalVincularCorreo} onHide={handleHideModalVincularCorreo}>
                <Modal.Header closeButton>
                    <Modal.Title>Vinculación con Correos</Modal.Title>
                </Modal.Header>
                            
                <Modal.Body>
                    <div className="col-12">
                        <SearchModalEmail getEmails={getEmails} setIsSearched={setIsSearchedEmail}/>
                    </div>
                    
                    <div className="col-12">
                        {loadingEmail && <SpinnerBootrap/>}
                        <TableModalEmail vinculedEmail={vinculedEmail} emails={emails} getEmails={getEmails} totalPages={totalPagesEmail} setPage={setPageEmail} page={pageEmail} isSearched={isSearchedEmail} setIsSearched={setIsSearchedEmail} />                        
                    </div>
                    
                    <div className="col-12">
                        {loadingEmail && <SpinnerBootrap/>}
                        
                        <Table2ModalEmail
                            vinculedEmails={vinculedEmails}
                            desvinculedEmail={desvinculedEmail} 
                        />
                    </div>
                </Modal.Body>
            </Modal>
            
            
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Vinculación con Lineas</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="col-12">
                        {loading && <SpinnerBootrap/>}
                        {
                        <ClientCrudTableSearchModal
                            listLinesByNumber={listLinesByNumber}/>}
                    </div>
                    <div className="col-12">
                        {loading && <SpinnerBootrap/>}
                        {Lines && 
                        <ClientCrudTableModal
                            Lines={Lines} 
                            amountLinesPages={amountLinesPages}
                            listLines={listLines}
                            vinculedLine={vinculedLine}
                            numberPageLine={numberPageLine}
                            />}
                    </div>
                    <div className="col-12">
                        {loading && <SpinnerBootrap/>}
                        {LinesWhitClient && 
                        <ClientCrudTableModal2
                            LinesWhitClient={LinesWhitClient} 
                            listLinesByDocumentClient={listLinesByDocumentClient}
                            desvinculedLine={desvinculedLine}/>}
                    </div>
                </Modal.Body>
            </Modal>


        </>
    );
}
export default ClientCrud;
